import _ from "lodash";

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many additional seasonal employees do you employ?
 * 
 * == baseline
 * question70
 * 
 * Survey: PROJECT - FINAL IMPACT
 * Question: How many additional seasonal employees do you employ?
 * 
 * == final
 * question14
 * 
 * @param props 
 * @returns 
 */
export const newSeasonalContractsTotalCalculation = (props: any) => {
    return _.sumBy(props.finalSubmissions, 'question14') - _.sumBy(props.baselineSubmissions, 'question70');
}